module.exports = __webpack_public_path__ + "img/商店_u61.a24567af.svg";